(function() {
  $(document).on('turbolinks:load', function() {
    init();
  });

  var init = function() {
    handleEnableSelectMessage();
    handleCloseSelectMessage();
    handleEditButtonClick();
  }

  var handleCloseSelectMessage = function() {
    $('.chat-checkbox-topbar-remove').on('click', function() {
      $("input[checked='checked']").click();
      $(".chat-conversation .round").removeClass("open")
      $('.chat-topnav').show();
      $('.chat-checkbox-topbar').hide();

      if ($('.reply-content').html().length > 0) {
        $('.reply-section').show();
        $('.chat-conversation').addClass('reply-section-open');
        rollToBottom();
      }

      if ($('.forward-content').html()?.length > 0) {
        $('.forward-section').show();
        $('.chat-conversation').addClass('forward-section-open');
        rollToBottom();
      }
    })
  }

  var handleEnableSelectMessage = function() {
    $("#user-chat-show").delegate(".edit-conversation-btn", "click", function() {
      $(".chat-conversation .round").addClass("open")
      $('.chat-topnav').hide();
      $('.chat-checkbox-topbar').show();
      $('.chat-checkbox-topbar').find('.message-selected-number').html("");
    })
  }

  holdClick = function() {
    $('#my-chat-history li.conversation-messages').removeClass('delete-message');
    $('.chat-topnav').show();
    $('.chat-checkbox-topbar').hide();
    $('#message-content').show();
    $('.checkbox-bottombar').hide();
    $(".chat-message-delete").hide();
    $(".chat-message-copy-clipboard").hide();
    $(".chat-message-edit").hide();

    $('.arr_message_id').val('');
    delete_message_id = [];
    forwardUserNames = [];
    pollIds = [];

    $(".chat-conversation .round").removeClass("open")
    $("#my-chat-history li.conversation-messages").removeClass("clicked")
    $("input[checked='checked']").removeAttr("checked")
  }

  handleLongPress = function(elements) {
    elements.on("long-press", function() {
      $(".chat-conversation .round").addClass("open")
      $(this).click();
    })
  }

  handleSelectMessage = function(elements) {
    elements.on("click", function() {
      if ($(".chat-conversation .round").hasClass("open")) {
        if ($(this).attr('id')) {
          const messageId = parseInt($(this).attr('id').substring(8));
          if ($(this).attr('message-type') == 'poll') {
            if (pollIds.includes(messageId)) {
              const index = pollIds.findIndex(dt => dt === messageId)
              pollIds.splice(index, 1)
            } else {
              pollIds.push(messageId)
            }
          }

          if ($(this).find('.message-check').attr("checked") === "checked") {
            $(this).find('.message-check').attr("checked", false)
            $(this).removeClass("clicked");

            let pos = delete_message_id.findIndex(dt => dt === messageId)
            delete_message_id.splice(pos, 1);
          } else {
            $(this).addClass("clicked");
            $(this).find('.message-check').attr("checked", true);
            delete_message_id.push(messageId);
          }

          let countChoose = delete_message_id.length;
          let pollCount = pollIds.length;
          handleTopbar(countChoose);
          handleReply(countChoose);
          handleBottomBar(countChoose)
          handleForward(countChoose, pollCount)
          handleShowOnRemoveMessageModel(countChoose);
          handleShowAlsoRemoveMessageModel()
          checkEditButtonVisibility();
        }
      }
    })
  }

  var handleShowAlsoRemoveMessageModel = function() {
    const otherAuthors = delete_message_id.flatMap((x) => `#message-${x}.left`).join(",");
    const otherAuthorCount = $(otherAuthors).length
    const roomId = $('#my-chat-history').attr('room_id')
    const roomData = roomList.find(element => element.id === parseInt(roomId))
    const current_user_id = parseInt(sessionStorage.getItem('current_user_id'));

    if (roomData && roomData.roomType !== 'broadcast') {
      if (current_user_id === roomData.adminId || otherAuthorCount === 0 || roomData.roomType === 'dirrect') {
        $("#confirm-remove-message-content .also-delete-block").html(`<div class="mb-3">
          <label>
            <input type="checkbox" class="form-check-input" name="with_participant" value="1">
            &nbsp;Also delete <span class='content-remove-message-modal'></span> for ${ roomData.roomType === 'dirrect' ? htmlEncode(roomData.roomName) : "your group's participants" }
          </label>
        </div>`)
      } else {
        $("#confirm-remove-message-content .also-delete-block").html('')
      }
    } else {
      $("#confirm-remove-message-content .also-delete-block").html('')
    }
  }

  var handleShowOnRemoveMessageModel = function(countChoose) {
    if (countChoose > 1) {
      $("#confirm-remove-message-content .confirm-text").text("Are you sure you want to delete these messages")
    } else {
      $("#confirm-remove-message-content .confirm-text").text("Are you sure you want to delete this message")
    }
  }

  var handleTopbar = function(countChoose) {
    if (countChoose === 0) {
      $('.chat-checkbox-topbar').hide();
      $('.chat-topnav').show();
      $(".chat-conversation .round").removeClass("open")

      $(".chat-message-delete").hide();
      $(".chat-message-copy-clipboard").hide();
      $(".chat-message-edit").hide();
    } else {
      $('.chat-checkbox-topbar').show();
      $('.chat-topnav').hide();
      $('.chat-checkbox-topbar').find('.message-selected-number').html(countChoose);
      $(".chat-message-delete").show();
      $(".chat-message-copy-clipboard").show();

      // Show edit button only if selected message is from current user
      checkEditButtonVisibility();
    }
  }

  var checkEditButtonVisibility = function() {
    if (delete_message_id.length === 1) {
      const messageId = delete_message_id[0];
      const current_user_id = parseInt(sessionStorage.getItem('current_user_id'));
      const messageElement = $(`#message-${messageId}`);

      // Check if message is from current user and is a text message
      const isCurrentUserMessage = messageElement.hasClass('right');
      const messageType = messageElement.attr('message-type');

      if (isCurrentUserMessage && messageType === 'text') {
        $('.chat-message-edit').show();
      } else {
        $('.chat-message-edit').hide();
      }
    } else {
      $('.chat-message-edit').hide();
    }
  }

  var handleBottomBar = function(countChoose) {
    if (countChoose === 0) {
      $('#message-content').show();
      $('.checkbox-bottombar').hide();
    } else {
      $('#message-content').hide();
      $('.checkbox-bottombar').show();
    }
  }

  var handleForward = function(countChoose, pollCount) {
    if (countChoose === 0 || pollCount > 0) {
      $('.checkbox-forward').hide();
    } else {
      $('.checkbox-forward').show();
    }
  }

  var handleReply = function(countChoose) {
    if (countChoose == 1 && currentRoomType != "broadcast") {
      $('.checkbox-reply').children().show();
    } else {
      $('.checkbox-reply').children().hide();
    }
  }

  var handleEditButtonClick = function() {
    $(document).on('click', '.chat-message-edit', function() {
      if (delete_message_id.length === 1) {
        const messageId = delete_message_id[0];
        const roomId = $('#my-chat-history').attr('room_id');
        const messageElement = $(`#message-${messageId}`);
        const messageContent = messageElement.find('.message-content').text();

        // Show edit modal
        showEditMessageModal(messageId, roomId, messageContent);

        // Close selection mode
        holdClick();
      }
    });
  }

  var showEditMessageModal = function(messageId, roomId, currentContent) {
    const modalHtml = `
      <div class="modal fade" id="editMessageModal" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Message</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
              <div class="mb-3">
                <label for="editMessageContent" class="form-label">Message Content</label>
                <textarea class="form-control" id="editMessageContent" rows="4">${htmlEncode(currentContent)}</textarea>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary" id="saveEditMessage">Save Changes</button>
            </div>
          </div>
        </div>
      </div>
    `;

    // Remove existing modal if any
    $('#editMessageModal').remove();

    // Add modal to body
    $('body').append(modalHtml);

    // Show modal
    $('#editMessageModal').modal('show');

    // Handle save button click
    $('#saveEditMessage').on('click', function() {
      const newContent = $('#editMessageContent').val().trim();
      if (newContent && newContent !== currentContent) {
        saveEditedMessage(messageId, roomId, newContent);
      } else {
        $('#editMessageModal').modal('hide');
      }
    });
  }

  var saveEditedMessage = function(messageId, roomId, newContent) {
    $.ajax({
      url: '/conversations/edit_message',
      type: 'POST',
      data: {
        message_id: messageId,
        room_id: roomId,
        message: newContent
      },
      success: function(data) {
        if (data.success) {
          // Update roomList data
          const roomData = roomList.find(element => element.id === parseInt(roomId));
          if (roomData) {
            const messageIndex = roomData.conversations.findIndex(msg => msg.id === messageId);
            if (messageIndex !== -1) {
              roomData.conversations[messageIndex].message = newContent;
              roomData.conversations[messageIndex].editedAt = data.edited_at;
            }
          }

          // Update message content in DOM
          $(`#message-${messageId} .message-content`).text(newContent);

          // Add edited label if not already present
          addEditedLabel(messageId, data.edited_at);

          showToast('Message updated successfully', 'success');
          $('#editMessageModal').modal('hide');
        }
      },
      error: function(xhr) {
        console.error('Error editing message:', xhr.responseText);
        const errorMessage = xhr.responseJSON && xhr.responseJSON.error ? xhr.responseJSON.error : 'Error updating message';
        showToast(errorMessage, 'error');
        $('#editMessageModal').modal('hide');
      }
    });
  }

  var addEditedLabel = function(messageId, editedAt) {
    const messageElement = $(`#message-${messageId}`);
    const chatTimeElement = messageElement.find('.chat-time');

    // Check if edited label already exists
    if (chatTimeElement.find('.edited-label').length === 0) {
      const editedLabel = `<span class="edited-label text-muted" style="font-size: 12px; margin-left: 5px;">Edited at ${moment(editedAt).tz(curentTimezone).format('MMM DD, HH:mm')}</span>`;
      chatTimeElement.append(editedLabel);
    }
  }

  var showToast = function(message, type) {
    // Simple toast notification
    const toastClass = type === 'success' ? 'alert-success' : 'alert-danger';
    const toastHtml = `<div class="alert ${toastClass} alert-dismissible fade show" role="alert" style="position: fixed; top: 20px; right: 20px; z-index: 9999;">
      ${htmlEncode(message)}
      <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
    </div>`;

    $('body').append(toastHtml);

    // Auto remove after 3 seconds
    setTimeout(function() {
      $('.alert').fadeOut(function() {
        $(this).remove();
      });
    }, 3000);
  }
}).call(this);
